import { FreightDetailEntity } from 'Models/Entities';
import { whiteLabelStore } from 'Models/WhiteLabelStore';
import { roundToDecimals } from 'Util/_HumanWritten/NumberUtils';
import { UnitConverter } from 'Util/UnitOfMeasurementUtils';
import { FreightBookingWizardData } from '../../BookingWizardData/FreightBookingWizardData';

function getCubicPerUnitFromInnerWizardData(innerData: FreightBookingWizardData) {
	if (!innerData.length || !innerData.height || !innerData.width) {
		if (process.env.NODE_ENV === 'development') {
			console.warn(`A dimension is not valid: L=${innerData.length} W=${innerData.width} H=${innerData.height}`);
		}
		return 0;
	}

	const dimensions = {
		length: innerData.length,
		width: innerData.width,
		height: innerData.height,
		unitOfMeasurement: whiteLabelStore.systemMeasurementUnit,
	};

	return UnitConverter.getCubic(dimensions);
}

export function getCubicPerUnitFromFreightDetail(freightDetail: FreightDetailEntity) {
	if (!freightDetail.length || !freightDetail.height || !freightDetail.width) {
		if (process.env.NODE_ENV === 'development') {
			console.warn(
				`A dimension is not valid: L=${freightDetail.length} W=${freightDetail.width} H=${freightDetail.height}`,
			);
		}
		return 0;
	}

	const dimensions = {
		length: freightDetail.length,
		width: freightDetail.width,
		height: freightDetail.height,
		unitOfMeasurement: whiteLabelStore.systemMeasurementUnit,
	};

	return UnitConverter.getCubic(dimensions);
}

export function getTotalCubicFromInnerWizardData(innerData: FreightBookingWizardData) {
	return roundCubic(getCubicPerUnitFromInnerWizardData(innerData) * (innerData.quantity ?? 1));
}

export function getTotalWeightFromInnerWizardData(innerData: FreightBookingWizardData) {
	return (innerData.weight ?? 0) * (innerData.quantity ?? 1);
}

export function roundCubic(value: number) {
	return roundToDecimals(value, 4);
}

export function convertToCubicString(value: number) {
	return `${roundCubic(value).toString()} ${whiteLabelStore.volumeUnitLabel}`;
}

export function convertToWeightString(value: number) {
	return `${value.toString()} ${whiteLabelStore.massUnitLabel}`;
}
